import { getGeneratorTemplates } from 'modules/Rations/redux/modules/ration/selectors';

export default getGeneratorTemplates;
